// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"715":"list","962":"home","996":"chunk-common"}[chunkId] || chunkId) + "." + {"570":"62940b08","715":"35c5d28d","962":"8018e23e","996":"f58517fb"}[chunkId] + ".js";
};